export default {
    //首页内容
    index: {
        content: "「心光」是用户的 AI 生活伴侣，像是生活版的Notion。 你可以用它 All-in-one 记录生活：文字、语音、照片视频，灵感想法、情绪发泄、音乐播客、健身运动…… 与此同时，你自己亲自设定的 AI 朋友会主动回应你的心事，与你共鸣，或展开深入的探讨。",
        contentTips: "——日积月累，你会收获一本你自己的「人生之书」，和世界上最懂你的 AI 朋友。",
        iosDownload: "ios下载"
    },
    // 菜单
    header: {
        home: '首页',
        about: '关于我们'
    },
    //关于页面
    aboutUs: {
        content: "「心光」的使命：为用户构建有陪伴、有回应、有梳理的个人小世界，让想法和情绪被妥善照料。结合强大的 AI 能力，心光的 AI 朋友既是你生活的倾听者，也是得力助手，陪伴你的人生，伴随你成为更棒的自己。",   
        //联系我们
        contact: "联系我们",
        //注销账号
        contactTips1:"如需注销账号，请发邮件到：moodlightnlp2025@gmail.com，邮件中请提供您的手机号或邮箱信息，我们将第一时间为您处理！",
        contactTips2:"注销账号属于危险操作，请确认是否要注销账号。请注意如您完成注销账号操作后，您的账号会进入3天的账号删除冷静期，在冷静期中您再次登录此账号，将视为您取消账号注销，删除冷静期结束后，我们会删除您的账号信息且无法找回，由于您的应用数据保存在您的应用内，如您需要删除可直接删除应用，应用数据也会同步删除，望您知悉。",
    },
    // 隐私政策
    privacy_policy: {
        title: "隐私政策",
        company: "运营公司：深圳市心里有光科技有限公司",
        published_on: "本隐私政策于2024年12月20日发布。",
        updated_on: "本隐私政策于2025年04月07日更新。",
        description: "心光是由深圳市心里有光科技有限公司（以下简称“心里有光科技有限公司”或“我们”）为您提供是你的AI生活记录伴侣。心里有光科技有限公司十分重视您的个人信息和数据，并会尽全力保护您的个人信息和数据的安全可靠。本心光应用（下文简称“本应用”或“心光”）非常重视用户隐私政策并严格遵守相关的法律规定。请您仔细阅读《隐私政策》后再继续使用。如果您继续使用我们心里有光科技有限公司的服务，表示您已经充分阅读和理解我们协议的全部内容。",
        helpYouKnow: "本政策将帮助您了解以下内容：",
        sections: [
            "一、我们如何收集您的个人信息",
            "二、我们如何存储您的个人信息",
            "三、我们如何保障您的个人信息安全",
            "四、Cookie和同类技术的使用",
            "五、我们如何使用您的个人信息",
            "六、您如何管理您的信息",
            "七、信息披露",
            "八、我们如何处理儿童的个人信息",
            "九、本隐私政策的更改",
            "十、如何联系我们"
        ],
        disclaimer:"本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更优质的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。",

        //第一节
        section1:{
            declare:"在您使用心光服务的过程中，心光会按照如下方式收集您在使用服务时主动提供或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的帐号安全：",
            declares: [
                "1、当您注册心光服务时，我们会收集您的昵称、头像、手机号码，收集这些信息是为了帮助您完成心光注册，保护您心光帐号的安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若您不提供这类信息，您可能无法正常使用我们的服务。您还可以根据自身需求选择填写性别、描述等信息。",
                "2、当您使用心光服务时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的帐号安全，我们会收集您的设备型号、操作系统、唯一设备标识符（指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备）、登录IP地址、心光软件版本号、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如您在心光进行搜索、查看操作的记录、服务故障信息、引荐网址等信息）等日志信息，这类信息是为提供服务必须收集的基础信息。",
                "3、当您使用心光进行日常记录时，我们会获取您包括并不仅限于记录文本、照片、视频等您上传到心光的记录信息，您的这些信息将存储在应用内，您可以选择是否存储到心光的服务器，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。除非经您自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。",
                "4、当您通过订购会员等产品时产生的记录，包括订购记录、消费记录，这些信息会存储于我们的服务器中。以上信息为软件功能必须的信息。如您使用订购与支付功能，第三方向您提供支付服务的公司将直接收集与支付相关的信息。",
                "5、当您使用AI相关功能时，我们认为您允许心光将您在心光上产生的如记录信息等用户信息提供给第三方提供AI服务的公司，以获得AI的相关服务。",
                "6、当您使用本软件时，为提供给您服务之目的，心光可能获取您终端设备的如下权限，当然您可以拒绝开启以下权限，或在手机的设置中关闭本软件的以下权限，关闭以下权限不会影响您对本软件其他功能的使用：",
            ],
            //第六项拓展
            sixth:[
                "（1）访问相机：您可以使用摄像头直接拍摄并上传图片；",
                "（2）获取电话和接受短信：通过开启电话权限，实现手机号接收验证码短信注册登录；",
                "（3）访问本地存储：通过开启本地存储权限，实现应用的更新和本地照片与视频上传；",
                "（4）访问照片：您可以直接选择手机内的照片或图片进行上传；",
                "（5）开启无线数据：您可以通过连接无线网络或开启蜂窝网络来实现本软件需要的联网功能；",
                "另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：",
            ],
            //第六项重点
            sixthPoint:[
                "a) 与个人信息控制者履行法律法规规定的义务相关的；",
                "b) 与国家安全、国防安全直接相关的；",
                "c) 与公共安全、公共卫生、重大公共利益直接相关的；",
                "d) 与刑事侦查、起诉、审判和判决执行等直接相关的；",
                "e) 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；",
                "f) 所涉及的个人信息是个人信息主体自行向社会公众公开的；",
                "g) 根据个人信息主体要求签订和履行合同所必需的；",
                "h) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；",
                "i) 维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；",
                "j) 个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；",
                "k) 个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。",
            ],
            //请理解
            understand:"请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。",
            //请注意
            notice:"请您注意，目前心光不会主动从心光外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围。此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。",
        },
        //第二节
        section2: {
            //第二节小标题
            titles: [
                '1、信息存储的地点',
                "2、信息存储的期限",
                "3、账号信息的生成和注销",
            ],
            // 第一点
            firstPoint:"目前您的大部分数据存储于您的应用内，其它诸如账号信息等存储在心光服务器的信息，我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。如果您的个人信息存储地点从中国境内转移到境外的，我们将严格依照法律的规定执行。",
            // 第二点
            secondPoint: {
                content: "一般而言，我们仅在为实现目的所必需的时间内保留您的个人信息，例如",
                points:[
                    "手机号码：若您需要使用心光服务，我们需要一直保存您的手机号码，以保证您正常使用心光的相关服务，当您注销心光帐户后，我们将删除相应的信息；",
                    "用户信息：若您使用心光服务，我们需要一直保存您的昵称、性别、描述等信息，以保证您正常使用该服务，当您注销心光帐户后，我们将删除相应的信息；"
                ]
            },
            //第三点
            thirdPoint:[
                "当您通过应用内手机号时，我们将根据您的手机号生成您在应用内的账号。",
                "当您需要注销账号时，请通过[设置]-[账号与安全]-[注销账号]来进行账号的注销，当您注销账号后，我们将删除所有关于您的账号信息和用户信息，并无法找回，请在注销前确定导出您所需要的用户信息。",
            ],
        },
        //第三节
        section3:{ 
            content:[
                "我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。",
                "我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、匿名化处理等手段来保护您的个人信息。",
                "我们通过不断提升的技术手段加强安装在您设备端的软件的安全能力，以防止您的个人信息泄露。例如，我们为了安全传输会在您设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站，我们可能会了解您设备安装的应用信息、正在运行的进程信息或设备内存中寄存的数据；为了预防诈骗、盗号、仿冒他人等不法行为和进行安全检查可能会分析利用唯一设备标识符、登录IP地址、操作日志、地理位置信息等数据，以便于采取安全措施或进行安全提醒等。",
                "我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。",
                "若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。",
                "我们会尽力保护您的个人信息。我们也请您理解，任何安全措施都无法做到无懈可击。",
            ]
        },
        //第四节
        section4:{
            content: [
                "在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的服务，包括推广服务。",
                "通过本应用所设cookies所取得的有关信息，将适用本政策。",
            ]
        },
        //第五节
        section5: {
            content:[
                "我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将您在使用我们某一功能或服务时我们收集的信息，我们将会进行信息处理，将信息分析处理后再提供给您相关的统计服务，包括但不限于数据分类展示、对您阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准的服务和内容、保护用户权益或保护心光生态安全等。",
                "为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的任何个人身份信息相结合。",
                "如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。"
            ]
        },
        //第六节
        section6:{
            title:[
                "1、信息管理",
                "2、帐号注销",
            ],
            content1:[
                "我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正及删除的权利，以使您拥有充分的能力保障您的隐私和安全。",
                "当您发现我们处理关于您的信息有错误时，您有权要求我们做出更正或补充。我们在提供服务的过程中，可能需要您开通一些设备权限，例如相册、相机、麦克风、手机通讯录等访问权限。您可以在设备的【设置】功能中随时选择关闭部分或者全部权限，从而拒绝本应用收集您的个人信息。在不同的设备中，权限显示方式及关闭方式可能有所不同，具体参考设备及系统开发方说明或指引。",
            ],
            content2:[
                "您可以自行点击“洞见—>设置—>账号与安全—>注销账号 提示您通过手机号联系并验证真实身份。",
                "点击“确认注销”，经验证身份信息无误并且注销账号意图不变，我们会将您的账号进入删除冷静期，在删除冷静期过程中您将无法使用您的账号，但您可以要求我们恢复您的账号信息，待删除冷静期过后您的账号将被完全删除，如果您希望立即删除您的账号信息，您可以通过邮箱联系我们，我们将立即为您处理账号注销，此外由于您的其它数据存储在您的应用中，您可自行删除心光应用，您的数据也会被同步删除。",
                "您知悉并理解，注销账号的行为是不可逆的。在您主动注销账号之后，本应用将停止为您提供产品或服务，会尽快删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。",
            ],
        },
        // 第七节
        section7: {
            notice:"在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：",
            notices:[
                "(a) 未经您事先同意，我们不会向第三方披露；",
                "(b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；",
                "(c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；",
                "(d) 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；",
                "(e) 如您是合格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；",
            ],
            title:[
                "1、共享",
                "2、转让",
                "3、公开披露",
                "4、委托处理",
                "5、关于和第三方合作商的信息披露",
            ],
            content1:[
                {
                    title:"（1）其他用户查询",
                    content:"本应用中其他用户可以通过搜索查询到您再本应用中的用户主页或已发布的物品，方便用户之间的交换。"
                },{
                    title:"（2）投诉处理",
                    content:"当您投诉他人或被他人投诉时，为了保护您及他人的合法权益，维护本应用内绿色交换环境，我们可能会将您的姓名及有效证件号码、联系方式、投诉相关内容提供给有关部门，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。"
                },
            ],
            content2:{
                notice:"我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：",
                notices:[
                    "（1）事先获得您的明确同意；",
                    "（2）根据法律法规或强制性的行政或司法要求；",
                    "（3）在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息的处理目的、处理方式时，我们将要求该公司、组织重新取得您的明确同意。"
                ]
            },
            content3:{
                notice:"原则上我们不会将您的信息进行公开披露，如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明确同意。"
            },
            content4:{
                notice:"为了提升信息处理效率，降低信息处理成本，或提高信息处理准确性，我们可能会委托有能力的我们的关联公司或其他专业机构代表我们来处理信息。我们会通过书面协议、现场审计等方式要求受托公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。在委托关系解除时，受托公司不再保存个人信息。我们承诺对此负责。"
            },
            content5:{
                services:[
                    {
                        title:"1）支付服务提供商之一：由深圳市腾讯计算机系统有限公司为您提供服务，我们将会采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）以及网络信息与软件安装列表，用户为您提供支付服务，详情内容请访问",
                        policyName:"《微信隐私政策》",
                        sdkTips:"以下是支付服务提供商所需要使用到的相关SDK：",
                        link:"https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
                        tips:"微信 SDK：用于使用微信支付、微信分享和微信登录功能",
                    },{
                        title:"2）支付服务提供商之二：由支付宝（中国）网络技术有限公司为您提供服务，我们将会采集IMEI、IMSI、MAC 地址、设备序列号、硬件序列号、SIM卡序列号、ICCID、AndroidID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi列表；软件安装列表，用于为您提供支付服务，详细内容请访问",
                        policyName:"《支付宝隐私权政策》",
                        sdkTips:"以下是信用服务供应商所需要使用到的相关SDK：",
                        link:"https://opendocs.alipay.com/common/02kiq3",
                        tips:"支付宝支付 SDK：用于使用支付宝支付",
                    },{
                        title:"3）异常上报服务提供商：由腾讯科技（北京）有限公司为您提供服务，我们将会采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）以及网络信息，将用户在使用过中出现的异常上报给我们，来进一步提升用户体验，详细内容请访问",
                        policyName:"《Bugly Crash SDK隐私保护声明》",
                        sdkTips:"以下是异常上报服务提供商所需要使用到的相关SDK：",
                        link:"https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
                        tips:"腾讯 Bugly SDK：用于统计应用内出现崩溃的问题.",
                    },{
                        title:"4）分享服务提供商之一：由行吟信息科技（上海）有限公司️为您提供服务，我们将会采集常用设备信息（操作系统、系统版本、设备型号）以及网络信息，用于为您提供小红书分享服务，详情内容请访问",
                        policyName:"《小红书Open SDK个人信息处理说明》",
                        sdkTips:"以下是分享服务提供商所需要使用到的相关SDK：",
                        link:"https://agree.xiaohongshu.com/h5/terms/ZXXY20230525001/-1",
                        tips:"- 小红书分享SDK：用于完成跳转到小红书进行分享",
                    },{
                        title:"5）语音识别服务提供商：由阿里云计算有限公司为您提供服务，使用过程中不会收集您的设备信息，为您提供语音识别服务，详细内容请访问",
                        policyName:"《智能语音交互产品隐私政策》",
                        sdkTips:"以下是语音识别服务提供商所需要使用到的相关SDK：",
                        link:"https://terms.alicdn.com/legal-agreement/terms/b_platform_service_agreement/20240325163900980/20240325163900980.html?spm=a2c4g.11186623.0.0.62e34f4dX2l2z4",
                        tips:"- 智能语音交互移动端SDK：用于进行智能语音交互",
                    },{
                        title:"6）号码认证服务提供商：由阿里云计算有限公司为您提供服务，我们将会采集网络类型、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM State），用于为您提供手机号一键登录服务，详情内容请访问",
                        policyName:"《号码认证服务隐私权政策》",
                        sdkTips:"以下是号码认证服务提供商所需要使用到的相关SDK：",
                        link:"https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.7e503079Pt4iQ9",
                        tips:"- 号码认证服务SDK：用于实现手机号一键登录",
                    }
                ],
                notice:"此外，当软件在后台运行时部分第三方SDK收集个人信息情况的告知：",
                noticeTips:"（1）腾讯Bugly SDK在后台运行时会读取SD卡存储相关内容，其需要读取应用的相关信息，将产生的崩溃情况和具体崩溃产生的位置上报到服务器",
            },
        },
        // 第八节
        section8: {
            content:[
                "我们非常重视儿童个人信息的保护，我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的用户账户。尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。",
                "对于经父母或监护人同意而收集儿童用户信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下储存、使用或公开披露此信息，否则我们会设法尽快删除相关数据。",
                "鉴于现有技术和业务模式的限制，我们很难主动识别儿童的个人信息，如果您发现我们在不知情的情况下或在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，您可以及时联系我们，我们将在发现后设法及时删除，如果我们自己发现前述情形的，我们也会及时删除，法律要求我们保留的除外。",
            ]
        },
        // 第九节
        section9: {
            content:[
                "(a)如果决定更改隐私政策，我们会在本政策中、本公司网站中以及本应用的系统消息中进行通知，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。",
                "(b)本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会以系统消息和短信的形式告知。",
                "(c)请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。",
                "感谢您花时间了解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！"
            ]
        },
        //第十节
        section10:{
            noticePre:"我们设立了个人信息保护专职部门，将按照本政策保护您的个人信息。如您有关于网络信息安全的投诉和举报，或您对本政策、心光的隐私措施、您的信息的相关事宜有任何问题、意见或建议，请与心光的个人信息保护工作人员联系，可发送邮件至",
            noticeSub:"一般情况下，我们将在收到您的问题、意见或建议，并验证您的用户身份后的十五天内予以回复。",
        }
    },
    // 用户协议
    agreement: {
        mainTitle:"用户协议",
        company:"运营公司：深圳市心里有光科技有限公司",
        published_on: "本隐私政策发布于：2024年12月20日",
        updated_on: "本隐私政策更新于：2025年1月1日",
        title:[
            "1. 您的权利",
            "2. 服务条款的接受与修改",
            "3. 会员服务购买声明",
            "4. 会员的购买",
            "5.会员的有效期以及退订",
            "6.协议的有效期和终止",
            "7.违约责任",
            "8.争议解决和法律适用",
        ],
        //第一节
        section1: {
            notice: "我们非常重视您的隐私与个人信息安全，您的信任对我们至关重要。根据中国的法律法规，我们为您提供以下权利，确保您的个人信息安全、可控：",
            title:[
                "（一）访问您的个人信息",
                "（二）修改您的个人信息",
                "（三）删除您的个人信息",
                "（四）改变您授权的范围",
                "（五）注销账户",
                "（六）响应您的上述请求",
            ],
            firstNotice:"您有权访问您的个人信息，法律法规规定的例外情况除外，可以通过以下方式进行访问：",
            firstTips:"访问昵称、性别、描述等基本信息：",
            firstTipsSteps:[
                "进入后，点击“陪伴”",
                "点击最上方的AI朋友区域",
                "进行个人信息信息查询",
            ],
            secondNotice:"当您发现您的个人信息有错误时，您可直接通过“(一)访问您的个人信息”的路径对您的个人信息直接进行修改。",
            thirdNotice:"在以下情形中，您可以向我们提出删除个人信息的请求：",
            thirdTips:[
                "如果我们在处理您的个人信息时违反法律法规；",
                "如果我们收集或使用您的个人信息时未征得您的同意；",
                "如果我们处理您的个人信息时违反了与您的约定；",
                "如果您不再使用我们的产品或服务或您注销了账号；",
                "如果我们不再为您提供产品或服务。",
            ],
            thirdEnd:[
                "若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。",
                "删除方式：当您从我们的服务中删除信息后，我们可能不会立即从系统中删除相应的信息，我们会设立一段删除冷静期，在这段时间内您还可以要求我们为您回恢复您的个人信息，待删除冷静期过后，您的数据将会被彻底删除。",
            ],
            fourthNotice:"每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。 当您收回同意后，我们将不再处理相应的个人信息。",
            
            fifthNotice:"您随时可注销此前注册的账户，您可以通过以下方式自行操作：",
            fifthNoticeSteps:[
                "进入后，点击“洞见”",
                "点击“设置”",
                "点击“账号与安全”",
                "点击“注销账号”",
            ],
            fifthTips:"在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。",
            fifthOtherWise:"在以下情形中，按照法律法规要求，我们将无法响应您的请求：",
            fifthOtherSteps:[
                "与国家安全、国防安全直接相关的；",
                "与公共安全、公共卫生、重大公共利益直接相关的；",
                "与犯罪侦查、起诉、审判和判决执行等直接相关的；",
                "有充分证据表明您存在主观恶意或滥用权利的；",
                "响应您的请求将导致您或其他个人、组s织的合法权益受到严重损害的；",
                "涉及商业秘密的。",
            ],
            sixthNotice:[
                "为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。 我们将在验证您身份后的三十天内作出答复。如您不满意，还可以依法向政府或者行业主管部门投诉。",
                "对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。",
                "在以下情形中，我们将无法响应您的请求：",
            ],
            sixthSteps:[
                "与个人信息控制者履行法律法规规定的义务相关的；",
                "与国家安全、国防安全直接相关的；",
                "与公共安全、公共卫生、重大公共利益直接相关的；",
                "与刑事侦查、起诉、审判和执行判决等直接相关的；",
                "个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；",
                "出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
                "响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；",
                "涉及商业秘密的。",
            ]
        },
        //第二节
        section2:{
            notice:[
                "本协议是深圳市心里有光科技有限公司旗下app心光用户（以下简称“用户”）与深圳市心里有光科技有限公司关于用户权利所订立的协议，本协议描述深圳市心里有光科技有限公司与用户之间关于本服务的使用以及相关方面的权利义务，用户选择使用本服务的行为将视为同意本协议各项条款的约束。",
                "本协议如需修改，会将修改部分或新规定通过网站公告发布，会员应及时关注并遵守，所有规定为协议不可分割的组成部分，与本协议正文具有同等效力。若有关规定与本协议不一致，以生效日期在后的规定准。",
            ]
        },
        //第三节
        section3:{
            notice:[
                "本服务是在用户期望开通会员以享受AI相关服务的，明确会员与非会员的权利范围，避免因不明确会员范围而造成损失而推出的服务。",
                "来电、AI聊天和每周来信等服务，此会员服务范围并只局限于以上部分，在未来的开发中，心光将推出更多会员服务来满足会员用户不同的需求。",
                "如在扣费过程中出现差错，用户应积极配合深圳市心里有光科技有限公司查明原因，各自承担己方过错所造成的损失；若因双方各自存在不均等过错造成的损失，由双方按照各自造成损失的程度承担相应的责任。",
                "除心光应用内的会员购买方式，任何在心光之外付款或者以恶意破解等非法手段获取到心光会员服务的行为，均不属于本协议约定的会员服务。由此产生的一切法律后果由行为人负责，深圳市心里有光科技有限公司有权依法追究行为人的法律责任。",
            ]
        },
        //第四节
        section4: {
            notice:[
                "深圳市心里有光科技有限公司在心光应用内，向用户提供了微信、支付宝等支付渠道，便于用户在选择不同会员时长时选择不同的支付方式进行支付来获取心光会员，享受心光会员服务。",
                "如遇支付成功，但会员时长未增加或会员权利未生效，请及时联系深圳市心里有光科技有限公司，深圳市心里有光科技有限公司将及时为您处理您的会员生效问题。",
            ]
        },
        //第五节
        section5:{
            notice:"除非深圳市心里有光科技有限公司另行规定或出现无法继续提供会员服务的情况下，否则用户获得会员服务长期有效。因心光会员属于虚拟产品，在您开通会员并完成支付时，深圳市心里有光科技有限公司将认为您已了解本服务协议并明确会员所享受的权利范围，因会员一经开通立刻生效，除非法律规定的情况或深圳市心里有光科技有限公司提供的服务范围与本协议所描述的会员权利不相符，否则无法退订和退款。",
        },
        //第六节
        section6:{
            notice:"本协议自会员选择接受或使用本服务后生效，直至会员终止本服务或注销会员资格时终止。此外如深圳市心里有光科技有限公司无法再提供本协议所规定的相关服务时，本协议也将终止，但深圳市心里有光科技有限公司会在上述情况发生前积极与心光用户取得联系并告知用户本协议终止的时间，保障用户权利。",
            otherWise:"如发生以下任何一种情况，深圳市心里有光科技有限公司有权随时终止本协议向用户提供的服务，无需对用户或第三方承担任何责任，由此造成的损失由用户自行独立承担：",
            case:[
                "用户违反中华人民共和国相关法律法规或本协议中规定的使用规则；",
                "用户侵犯个人、企事业单位或社会团体的合法权益，包括但不限于专利权、著作权、商标权、姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等。",
                "不允许发布令人反感的内容动态，例如：色情、恐怖、涉政、暴力、血腥、辱骂、广告等。",
            ]
        },
        //第七节
        section7:{
            notice:"如果一方违约，守约方有权通过双方约定的争议解决方式获得补偿。",
        },
        //第八节
        section8:{
            notice:"深圳市心里有光科技有限公司与用户应通过协商来解决本协议在履行过程中所产生的争议，经协商无法解决的，任何一方均有权将争议提交诉讼解决。本协议的解释、效力和执行等有关问题均适用中华人民共和国法律。",
        }
    }
};
